import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { DipStateService } from '../services/dip-state-service.service';
import { TogetherDIPStage } from '../models/app.models';
import { environment } from '../../environments/environment';

@Component({
    selector: 'together-dev-header',
    templateUrl: './dev-header.component.html',
    styleUrls: ['./dev-header.component.scss'],
    standalone: false
})
export class DevHeaderComponent implements OnInit {
    @Input() buildReference: string;
    get isProduction(): boolean {
        return environment.production;
    }

    get env(): string {
        return environment.env;
    }

    constructor() { }
    ngOnInit() { }
}
